export default "__VITE_ASSET__CU37jQOb__"